<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row class="cs-titleContainer">
              <el-col :span="20">
                <span class="cs-title">问卷管理</span>
              </el-col>
              <el-col :span="4" class="cs-buttons">
                <el-button type="primary" size="medium" :disabled="loading" :loading="isExporting" @click="onExportClick">导出填写记录</el-button>
              </el-col>
            </el-row>
            <el-row class="cs-search-conditions margin-top-10" :gutter="20" v-loading="isConditionLoading">
              <el-col :span="4">
                <el-select placeholder="学期" size="medium" :disabled="loading" v-model="searchCondition.termId" @change="onTermChange">
                  <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id" />
                </el-select>
              </el-col>
              <el-col :span="20" class="cs-buttons">
                <!-- <el-button type="primary" :disabled="loading" size="medium" @click="search()">搜索</el-button> -->
                <el-button v-if="hasAddButton" type="primary" :disabled="loading" size="medium" @click="onAddClick">添加</el-button>
              </el-col>
            </el-row>
            <el-row class="grid-content">
              <el-col>
                <pagination v-loading="loading" :data="tablePageData" :option="paginationOption" @search="search" @loadData="onLoadList"
                  @pageSizeChange="pageSizeChange" @currentPageChange="currentPageChange" @edit="onPaginationEdit" @delete="onPaginationDelete"
                  @additional="onAdditional">
                  <template #Description="{value}">{{!!value && value.length > 20 ? `${value.substring(0, 20)}...` : value}}</template>
                  <template #StartTime="{value}">{{$moment(value).format(GLOBAL.MomentDateFormatCHN)}}</template>
                  <template #EndTime="{value}">{{!!value ? $moment(value).format(GLOBAL.MomentDateFormatCHN) : ""}}</template>
                  <template #CourseBasicCategories="{value}">{{GLOBAL.enumCourseBasicCategory.getJoinText(value)}}</template>
                  <template #Enable="{value}">{{value ? "启用" : "停用"}}</template>
                </pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>

    <questionnaireEditor key="questionnaireEditor" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :readonly="isReadonly" :data="editorData"
      :termId="currentTermId" :maxIndex="maxIndex" :customValidator="handleEditorCustomValidator" @change="onEditorChange" />
  </div>
</template>

<script>
import { downloadFile } from "@/config/mUtils";
import { getTerms } from "@/service/common.service";
import {
  getQuestionnairePageData,
  deleteQuestionnaire,
  cloneQuestionnaire,
  exportStudentQuestionnaireRecords,
} from "@/service/questionnaire.service";

const default_tablePageData = {
  AdditionalResult: {},
  Columns: [],
  CurrentPage: 1,
  PageCount: 0,
  PageSize: 20,
  RecordCount: 0,
  Results: [],
};

export default {
  name: "questionnaireList",
  components: {
    navigator: () => import("@/components/navigator"),
    pagination: () => import("@/components/common/pagination"),
    questionnaireEditor: () =>
      import("@/components/questionnaire/questionnaireEditor"),
  },
  data() {
    return {
      loading: false,
      isConditionLoading: false,
      isExporting: false,
      pageSize: 20,
      paginationOption: {},
      searchCondition: {
        termId: null,
      },
      termList: [],
      currentTermId: null,
      tablePageData: Object.clone(default_tablePageData),
      editorData: null,
    };
  },
  created() {
    let routeQuery = this.$route.query;
    if (!!routeQuery.termId) {
      this.currentTermId = `${routeQuery.termId}`.toNumber();
    }

    let additionalColumns = [
      {
        name: "viewQuestionList",
        title: "",
        buttonText: "问题列表",
        width: 100,
      },
      {
        name: "clone",
        title: "",
        buttonText: "克隆",
      },
    ];

    this.paginationOption = {
      displayPagination: false,
      hasAddButton: false,
      hasEditButton: true,
      hasDeleteButton: true,
      hasDeleteButtonWithEdit: true,
      hasSearch: false,
      fixedAction: "right",
      buttonWidth: 80,
      additionalColumns: additionalColumns,
      fnRowEditButtonText: (index, row) =>
        !this.isReadonly && !row.HaveStudentRecords ? "编辑" : "查看",
      fnRowDeleteVisible: (index, row) =>
        !this.isReadonly && !row.HaveStudentRecords,
    };

    this.init();
  },
  computed: {
    isReadonly() {
      return false;
    },
    hasAddButton() {
      return !this.isReadonly;
    },
    maxIndex() {
      let allIndexes = this.tablePageData.AdditionalResult["AllIndexes"];
      if (!allIndexes || allIndexes.length === 0) return 0;

      return allIndexes.length > 0 ? Math.max(...allIndexes) : 0;
    },
  },
  methods: {
    // 和服务端进行数据交互相关方法
    async loadTermsFromServer() {
      try {
        let result = await getTerms(false, true);
        this.termList = !!result && result.success ? result.data : [];
        let currentTerm = null;
        if (this.termList.length > 0) {
          if (!!this.currentTermId) {
            currentTerm = this.termList.find((i) => i.Id == this.currentTermId);
          } else {
            currentTerm = this.termList.find((i) => i.IsCurrentTerm);
            if (!currentTerm) currentTerm = this.termList[0];
          }
        }
        this.searchCondition.termId = !!currentTerm ? currentTerm.Id : null;
      } catch (error) {
        console.error(error);
      }
    },
    async loadQuestionnairePageDataFromServer(pageCondtion) {
      this.loading = true;
      try {
        let result = await getQuestionnairePageData(pageCondtion);
        if (!!result && result.success) {
          this.tablePageData = result.data;
        } else {
          this.tablePageData = Object.clone(default_tablePageData);

          this.$message.error(result.message);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async deleteQuestionnaireToServer(id) {
      this.loading = true;

      try {
        let result = await deleteQuestionnaire(id);
        if (!!result && result.success) {
          this.$message({
            message: "删除问卷成功",
            type: "success",
          });
          return true;
        } else {
          this.$message({
            message: result.message || "删除问卷失败",
            type: "error",
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }

      return false;
    },
    async cloneQuestionnaireToServer(id, termId) {
      this.loading = true;

      try {
        let result = await cloneQuestionnaire(id, termId);
        if (!!result && result.success) {
          this.$message({
            message: "克隆问卷成功",
            type: "success",
          });
          return true;
        } else {
          this.$message({
            message: result.message || "克隆问卷失败",
            type: "error",
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }

      return false;
    },
    async exportStudentQuestionnaireRecordsFromServer() {
      let termId = this.currentTermId;

      this.isExporting = true;
      try {
        let result = await exportStudentQuestionnaireRecords(termId);
        if (!!result && result.success) {
          downloadFile(result);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isExporting = false;
      }
    },

    async init() {
      this.isConditionLoading = true;
      await this.loadTermsFromServer();
      this.isConditionLoading = false;

      await this.search();
    },
    onTermChange() {
      this.search();
    },
    getSearchPageCondition(pageNumber) {
      if (!pageNumber) {
        pageNumber = 1;
      }

      let additionalFilter = {
        termId: this.currentTermId,
      };

      let pageCondition = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        additionalFilter: additionalFilter,
      };

      return pageCondition;
    },
    search(pageNumber) {
      this.currentTermId = this.searchCondition.termId;
      let pageCondition = this.getSearchPageCondition(pageNumber);
      this.loadQuestionnairePageDataFromServer(pageCondition);
    },
    onLoadList(pageData) {
      this.search(pageData.pageNumber);
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.tablePageData.CurrentPage = value;
    },
    openEditor() {
      let refEditor = this.$vueRefStore.getChildrenRef("questionnaireEditor");
      if (!refEditor) return;

      refEditor.showDialog();
    },
    closeEditor() {
      let refEditor = this.$vueRefStore.getChildrenRef(
        "studentVipCourseRecordEditor"
      );
      if (!refEditor) return;

      refEditor.closeDialog();
    },
    onAddClick() {
      this.editorData = null;
      this.openEditor();
    },
    onPaginationEdit(index, row) {
      this.editorData = row;
      this.openEditor();
    },
    onPaginationDelete(index, row) {
      this.$confirm("您确定要删除该问卷吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let result = await this.deleteQuestionnaireToServer(row.Id);
          if (result) {
            this.search();
          }
        })
        .catch(() => {});
    },
    onAdditional(name, index, row) {
      switch (name) {
        case "viewQuestionList": {
          let navList = JSON.stringify([
            {
              path: this.$route.path,
              data: {
                termId: this.currentTermId,
              },
            },
          ]);

          this.$router.push({
            path: "/questionnaire/questionnaireQuestionList",
            query: {
              questionnaireId: row.Id,
              navList: this.$cryptoJS.enc.Base64.encode(navList),
            },
          });
          break;
        }
        case "clone": {
          this.$confirm(`您确定要克隆该问卷到当前学期吗?`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              let result = await this.cloneQuestionnaireToServer(
                row.Id,
                this.searchCondition.termId
              );
              if (result) {
                let currentTerm = this.termList.find((i) => i.IsCurrentTerm);
                if (!!currentTerm) this.searchCondition.termId = currentTerm.Id;
                this.search();
              }
            })
            .catch(() => {});
          break;
        }
      }
    },
    handleEditorCustomValidator(value, fieldName, model) {
      let result = {};

      switch (fieldName) {
        case "Index": {
          let allIndexes = this.tablePageData.AdditionalResult["AllIndexes"];
          let indexUsed = allIndexes.contains(value);
          if (indexUsed && model.Id > 0) {
            let matchedItem = this.tablePageData.Results.find(
              (item) => item.Id === model.Id
            );
            indexUsed = matchedItem.Index !== value;
          }
          result[fieldName] = {
            success: !indexUsed,
            message: indexUsed ? "序号已被其他问卷使用" : null,
          };
          break;
        }
      }

      return result;
    },
    onEditorChange() {
      this.search();
    },
    onExportClick() {
      this.exportStudentQuestionnaireRecordsFromServer();
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-buttons {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/page/questionnaire/questionnaireList.vue